import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import Latex from "./utils/latex";
import { t } from "@/lib/localization";

export interface HintProps {
    label: string;
    keyName?: string;
    children: React.ReactNode;
    side?: "top" | "bottom" | "left" | "right";
    align?: "start" | "center" | "end";
    sideOffset?: number;
    alignOffset?: number;
    tooltipClassName?: string;
    latex?: boolean;
}

export const Hint = ({
    label,
    keyName,
    children,
    side,
    align,
    sideOffset,
    alignOffset,
    tooltipClassName,
    latex,
}: HintProps) => {
    return (
        <TooltipProvider>
            <Tooltip delayDuration={100}>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent
                    className={cn(
                        "whitespace-pre-line text-white bg-slate-800 border-slate-800 font-semibold",
                        tooltipClassName
                    )}
                    side={side}
                    align={align}
                    sideOffset={sideOffset}
                    alignOffset={alignOffset}
                >
                    {latex ? (
                        <Latex text={label} />
                    ) : keyName ? (
                        t(keyName, undefined, undefined)
                    ) : (
                        label
                    )}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
